export * from './variant-a/calendar-variant-a.module'
export * from './variant-a/calendar-variant-a.component';

